import React from 'react';
import ListItem from "@mui/material/List";

const menus = [
    {
        id: 1,
        title: 'Home',
    },
    {
        id: 3,
        title: 'Pages',
    },
    {
        id: 5,
        title: 'Services',
    },
    {
        id: 7,
        title: 'Casestudy',
    },
    {
        id: 6,
        title: 'Blog',
    },
    {
        id: 88,
        title: 'Contact',
    }
]

const MobileMenu = () => {

    return (
        <ul className="xb-menu-primary clearfix">
            {menus.map((item, mn) => {
                return (
                    <ListItem key={mn}>
                        <span className="menu-link-disabled" aria-disabled="true">{item.title}</span>
                    </ListItem>
                )
            })}
        </ul>
    )
}

export default MobileMenu;
